import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";
import Add from "./Add";
import Edit from "./Edit";
import Users from "./Users";

function UserRoutes(): JSX.Element {
    return (
        <Routes>
            <Route path="add" element={<Add />} />
            <Route path=":userId/edit" element={<Edit />} />
            <Route index element={<Users />} />
        </Routes>
    );
}

export default UserRoutes;
